import React, { useEffect, useState } from "react";
import { CircularProgress, Divider, Skeleton } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import {
  ArrowBack,
  ArrowForwardIos,
  Close,
  Visibility,
} from "@mui/icons-material";
import { invoiceListFn } from "../../../Services/Invoices/InvoiceList";
import { createInvoiceFn } from "../../../Services/Invoices/CreateInvoice";
import { invoicePerItemFn } from "../../../Services/Invoices/InvoicePerItem";
import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

const MyInvoices = () => {
  const [data, setData] = useState([]);
  const [itemInvoice, setItemInvoice] = useState([]);
  const [state, setState] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const ref = React.createRef();

  const handleOpen = (orderId) => {
    !data?.invoice_no && createInvoice({ order_id: orderId });
    setState(true);
  };

  const myInvoicesData = () => {
    axiosInstance
      .post(API_URLS.invoiceDetail, { order_id: orderId })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {});
  };
  const { mutate: createInvoice, isLoading: isLoadingInvoice } =
    useMutation(createInvoiceFn);
  useEffect(
    () => {
      orderId && myInvoicesData();
    },
    // eslint-disable-next-line
    [orderId]
  );
  const { mutate: itemPerItem } = useMutation(invoicePerItemFn, {
    onSuccess: (res) => {
      setItemInvoice(res?.data?.data);
    },
  });
  const navigate = useNavigate();
  const { data: invoices, isLoading } = useQuery(
    ["Invoices"],
    () => invoiceListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="fixed h-16 z-50 flex items-center gap-5 bg-white dark:bg-zinc-900 py-4 px-2 shadow w-full">
        <ArrowBack onClick={() => navigate(-1)} />
        <p className="font-semibold text-lg">My Invoices</p>
      </div>

      <Divider />
      <div className="bg-zinc-200 dark:bg-zinc-700 px-3 py-[75px] min-h-[94vh] flex flex-col gap-2 w-full">
        {isLoading
          ? [0, 1, 2, 3, 4, 5, 6].map(() => {
              return (
                <div className="flex flex-col gap-4 px-5 p-4 bg-white dark:bg-zinc-900 rounded-lg w-full">
                  <Skeleton height={10} className="!scale-100 !w-full" />
                  <Skeleton height={10} className="!scale-100 !w-full" />
                  <Skeleton height={10} className="!scale-100 !w-full" />
                </div>
              );
            })
          : invoices?.data?.order_invoice_details?.map((item) => {
              return (
                <>
                  <div
                    className="flex justify-between items-center gap-5 px-5 p-2 bg-white dark:bg-zinc-900 rounded-lg w-full"
                    onClick={() => {
                      handleOpen(item.order_id);
                      setOrderId(item.order_id);
                    }}
                  >
                    <div className="flex flex-col text-sm gap-2">
                      <p>Invoice No : #{item.invoice_data.invoice_no}</p>
                      <p>Invoice Date : {item.invoice_data.date}</p>
                      <p>Order Status : {item.order_status}</p>
                    </div>
                    <ArrowForwardIos fontSize="20" />
                  </div>
                  <Drawer
                    anchor="right"
                    open={state}
                    className="!shadow-none"
                    onClose={() => setState(false)}
                  >
                    {isLoading || isLoadingInvoice ? (
                      <>
                        <div className="flex h-full lg:w-[790px] justify-center hide-scroll items-center">
                          <CircularProgress size="lg" color="primary" />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="fixed h-16 z-50 flex items-center gap-5 bg-white dark:bg-zinc-900 py-4 px-2 shadow w-full">
                          <ArrowBack onClick={() => setState(false)} />
                          <p className="font-semibold text-lg">My Invoices</p>
                        </div>
                        <div
                          ref={ref}
                          className="flex gap-5 py-[75px] flex-col  lg:w-[790px] w-[390px] p-5 lg:p-16"
                        >
                          <p className="font-semibold text-center p-1 w-full bg-black rounded text-white uppercase tracking-[0.7rem]">
                            Invoice
                          </p>
                          <span className="flex justify-between items-center my-2">
                            <img
                              src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/logobhaarat.svg"
                              alt=""
                              className="w-1/3"
                            />
                            <span className="flex flex-col gap-2">
                              <p className="font-semibold">
                                Invoice Number : #{data?.invoice_no}
                              </p>
                              <p className="font-semibold">
                                Invoice Date : {data?.date}
                              </p>
                            </span>
                          </span>
                          <span className="flex flex-col gap-5 w-full">
                            <p className="font-bold">Billing Address</p>
                            <span className="flex flex-col text-sm">
                              Mani Kant Sharma, Aara Groups, Indira Nagar,
                              Faizabad Rd, Lucknow, Uttar Pradesh, India, 226028
                            </span>
                          </span>
                          <span className="border-y py-2 font-bold">
                            Shipping Details
                          </span>
                          <span className="flex flex-col gap-1">
                            <p className="">Order Number : #{data?.order_id}</p>
                            <p className="">Order Date : {data?.date}</p>
                          </span>
                          <table className="w-full">
                            <thead className="border-y border-gray-300 !rounded">
                              <tr>
                                <th className="!p-2 !text-left">Items Name</th>
                                <th className="!p-2 !text-left">Quantity</th>
                                <th className="!p-2 !text-left">Price</th>
                                <th className="!p-2 !text-left"></th>
                              </tr>
                            </thead>
                            {itemInvoice?.length === 0 ? (
                              <tbody className="!overflow-y-auto">
                                {data?.items?.map((order) => {
                                  return (
                                    <tr className="border-b group border-gray-300">
                                      <td className="!p-2">
                                        {order.product_name}
                                      </td>
                                      <td className="!p-2">
                                        {order.quantity}x
                                      </td>

                                      <td className="!p-2">
                                        ₹{order.price * order.quantity}
                                      </td>
                                      <th className="!p-2 !text-left w-20">
                                        <Visibility
                                          onClick={() =>
                                            itemPerItem({
                                              order_item_id: order.id,
                                            })
                                          }
                                          className="cursor-pointer !hidden group-hover:!block bg-[#306BDE] rounded text-white !p-1"
                                        />
                                      </th>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            ) : (
                              <tbody className="!overflow-y-auto">
                                {itemInvoice?.map((order) => {
                                  return (
                                    <tr className="border-b group border-gray-300">
                                      <td className="!p-2">
                                        {order.product_name}
                                      </td>
                                      <td className="!p-2">
                                        {order.quantity}x
                                      </td>
                                      <td className="!p-2">
                                        ₹{order.item_code}
                                      </td>
                                      <td className="!p-2">
                                        ₹{order.price * order.quantity}
                                      </td>
                                      <th className="!p-2 !text-left w-20">
                                        <Close
                                          onClick={() => setItemInvoice([])}
                                          className="cursor-pointer !hidden group-hover:!block bg-[#306BDE] rounded text-white !p-1"
                                        />
                                      </th>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            )}
                          </table>
                          <div className="flex flex-col items-end gap-2 w-full">
                            <span className="flex justify-between w-full">
                              <p>Sub total:</p>
                              <p>₹{data?.total_price}</p>
                            </span>
                            <span className="flex justify-between w-full">
                              <p>Discount:</p>
                              <p>-₹{data?.coupon_discount_amount}</p>
                            </span>
                            <span className="flex justify-between w-full">
                              <p>Total Tax Amount:</p>
                              <p>+₹{data?.total_tax_amount}</p>
                            </span>
                            <span className="flex justify-between w-full">
                              <p>Delivery Fee:</p>
                              <p>
                                ₹
                                {data?.total_delivery_charge
                                  ? data?.total_delivery_charge
                                  : 0}
                              </p>
                            </span>
                            <span className="flex border-t border-gray-300 py-2 font-semibold w-full justify-between gap-4">
                              <p>Total Cost:</p>
                              <p>
                                ₹
                                {data?.total_price -
                                  data?.coupon_discount_amount +
                                  data?.total_tax_amount}
                              </p>
                            </span>
                          </div>
                          <div className="flex text-sm flex-col">
                            <p>
                              Description : Thank you for your order! Payment is
                              expected within 31 days; please process this
                              invoice within that time.
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </Drawer>
                </>
              );
            })}
      </div>
    </>
  );
};
export default MyInvoices;
